import { render, staticRenderFns } from "./Regionals.vue?vue&type=template&id=07c48400&"
import script from "./Regionals.vue?vue&type=script&lang=js&"
export * from "./Regionals.vue?vue&type=script&lang=js&"
import style0 from "./Regionals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports